import React, { useState } from "react";
import { SessionPage } from "./SessionPage";

export const WebSocketDemo: React.FC = () => {
  const [sessionId, setSessionId] = useState("demo-session-123");
  const [userId, setUserId] = useState("user-" + Math.random().toString(36).substr(2, 9));
  const [characterId, setCharacterId] = useState("char-warrior-001");
  const [showDemo, setShowDemo] = useState(false);

  if (showDemo) {
    return (
      <div>
        <div className="fixed top-4 right-4 z-50">
          <button
            onClick={() => setShowDemo(false)}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
          >
            Exit Demo
          </button>
        </div>
        <SessionPage
          sessionId={sessionId}
          userId={userId}
          characterId={characterId}
          isDM={userId === "dm-user" || userId.includes("dm")}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
      <div className="max-w-md w-full bg-gray-800 rounded-lg border border-gray-600 p-6">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-white mb-2">🎲 RPG WebSocket Demo</h1>
          <p className="text-gray-400">Test the real-time chat and dice rolling features</p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-gray-300 text-sm font-medium mb-1">Session ID</label>
            <input
              type="text"
              value={sessionId}
              onChange={(e) => setSessionId(e.target.value)}
              className="w-full px-3 py-2 bg-gray-700 text-white placeholder-gray-400 rounded border border-gray-600 focus:border-blue-500 focus:outline-none"
              placeholder="Enter session ID"
            />
          </div>

          <div>
            <label className="block text-gray-300 text-sm font-medium mb-1">User ID</label>
            <input
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              className="w-full px-3 py-2 bg-gray-700 text-white placeholder-gray-400 rounded border border-gray-600 focus:border-blue-500 focus:outline-none"
              placeholder="Enter your user ID"
            />
          </div>

          <div>
            <label className="block text-gray-300 text-sm font-medium mb-1">
              Character ID (Optional)
            </label>
            <input
              type="text"
              value={characterId}
              onChange={(e) => setCharacterId(e.target.value)}
              className="w-full px-3 py-2 bg-gray-700 text-white placeholder-gray-400 rounded border border-gray-600 focus:border-blue-500 focus:outline-none"
              placeholder="Enter character ID"
            />
          </div>

          <div className="pt-4">
            <button
              onClick={() => setShowDemo(true)}
              className="w-full px-4 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors font-medium"
            >
              Start Demo Session
            </button>
          </div>

          <div className="text-center pt-4 border-t border-gray-600">
            <p className="text-gray-400 text-sm mb-2">Demo Features:</p>
            <ul className="text-gray-500 text-xs space-y-1">
              <li>• Real-time chat with multiple message types</li>
              <li>• Dice rolling with formula support</li>
              <li>• WebSocket connection management</li>
              <li>• Auto-reconnection on disconnect</li>
              <li>• System notifications</li>
            </ul>
          </div>

          <div className="text-center pt-2">
            <p className="text-yellow-400 text-xs">
              ⚠️ Make sure the backend server is running on localhost:8080
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
